import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import RandomQuote from "../../components/RandomQuote/RandomQuote";

const VerifyPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // 'verifying', 'success', 'error'

  const [resendEmail, setResendEmail] = useState("");
  const [resendMessage, setResendMessage] = useState("");

  const handleResendVerification = async () => {
    setResendMessage("");
    try {
      const res = await fetch(
        `${import.meta.env.VITE_API_URL}/api/auth/resend-verification`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: resendEmail }),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to resend email");

      setResendMessage("Verification email sent. Please check your inbox.");
    } catch (err) {
      setResendMessage(`${err.message}`);
    }
  };

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const res = await fetch(
          `${import.meta.env.VITE_API_URL}/api/auth/verify/${token}`
        );
        const data = await res.json();

        if (!res.ok) throw new Error(data.error || "Verification failed");

        setStatus("success");
        setTimeout(() => navigate("/login"), 3000);
      } catch (err) {
        console.error("Verification error:", err);
        setStatus("error");
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="authentication-view">
      <div className="center-wrapper">
        {status === "verifying" && <p>... Verifying your email ...</p>}
        {status === "success" && (
          <p>&nbsp;&nbsp;Email verified! ... Redirecting to login ...</p>
        )}
        {status === "error" && (
          <>
            <h2>Verification Failed</h2>
            Your verification link may be invalid or expired.
            <br />
            <p>Enter email to resend verification link:</p>
            <input
              type="email"
              placeholder="Enter your email"
              value={resendEmail}
              onChange={(e) => setResendEmail(e.target.value)}
              className="flow-form-resend"
              required
            />
            <div className="options">
              <button
                className="flow-verification-button"
                onClick={handleResendVerification}
              >
                Resend verification email
              </button>
              {resendMessage && <p>{resendMessage}</p>}
              <p>
                <a className="link" href="/login">
                  &larr;or go back to login
                </a>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyPage;
